import Vue from 'vue';
export default Vue.extend({
    name: 'PageCaption',
    props: {
        caption: {
            type: String,
            required: true
        },
        stepNumber: {
            type: Number,
            required: false
        },
        totalStepsCount: {
            type: Number,
            required: false
        }
    },
    setup(props) {
        const setCaption = () => {
            const caption = props.caption;
            const stepNumber = props.stepNumber;
            const totalStepsCount = props.totalStepsCount;
            if (stepNumber && totalStepsCount) {
                return caption
                    .replace('{stepNumber}', stepNumber)
                    .replace('{totalStepsCount}', totalStepsCount);
            }
            return caption;
        };
        return {
            setCaption
        };
    }
});
